<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 28 28">
        <g fill="none" fill-rule="evenodd">
            <g>
                <g transform="translate(-814 -892) translate(815 893)">
                    <circle cx="13" cy="13" r="13" fill="#F2E2F4" stroke="#F2E2F4"/>
                    <path stroke="#833E93" stroke-linecap="round" d="M11.6 8.6h3.8c1.105 0 2 .895 2 2v5.6c0 1.105-.895 2-2 2H9.8c-1.105 0-2-.895-2-2v-3.852h0" transform="matrix(-1 0 0 1 25.2 0)"/>
                    <path stroke="#833E93" stroke-linecap="round" d="M12.2 13.8L18.6 7.4M16.2 7.4L18.6 7.4"/>
                    <path stroke="#833E93" stroke-linecap="round" d="M17.4 8.6L19.8 8.6" transform="rotate(90 18.6 8.6)"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'dialog-icon'
}
</script>